/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import { Model } from "../utils/json-api";

export class Action implements Model {

    static get TYPE() { return "Action"; }

    id: string;
    params: { [name: string]: any };
    result?: any;
}


// WEBPACK FOOTER //
// ./src/models/Action.model.ts